type ClerkErrorShape = {
  longMessage?: unknown;
  message?: unknown;
  errors?: unknown;
};

const nonEmptyMessage = (value: unknown): value is string =>
  typeof value === 'string' && value.trim().length > 0;

/**
 * Clerk errors can arrive either as a top-level error or in the first entry of
 * an `errors` collection. Preserve the most useful message from either shape
 * while still handling native `Error` instances and malformed unknown values.
 */
export const getClerkErrorMessage = (error: unknown, fallback: string): string => {
  if (!error || typeof error !== 'object') return fallback;

  const clerkError = error as ClerkErrorShape;
  const firstError =
    Array.isArray(clerkError.errors) &&
    clerkError.errors[0] != null &&
    typeof clerkError.errors[0] === 'object'
      ? (clerkError.errors[0] as ClerkErrorShape)
      : undefined;

  return (
    [clerkError.longMessage, clerkError.message, firstError?.longMessage, firstError?.message].find(
      nonEmptyMessage
    ) ?? fallback
  );
};
